module.exports = VuePropertyDecorator;